module.exports = __webpack_public_path__ + "static/makeNTU2025-61c40fc704969c6277a35d6f4a526135.png";